import { Dialog } from 'construct-ui';
import moment from 'moment';
import { v4 as uuidv4 } from 'uuid';
import UserAttributeListComponent from '../../../../components/common/user-attribute-list-select.component';
import DatePickerComponent from '../../../../components/date-picker/date-picker.component';
import paginationComponent from '../../../../components/pagination/pagination.component';
import SelectSiteComponent from '../../../../components/site/select-site.component';
import { formats as FORMATS } from '../../../../config/constants';
import taskTodoModel from '../../../../models/task-management/to-do-management.model';
import ViewBase from '../../../view-base.view';
import ToDoSiteDetailsView from './to-do-site-details.view';
import ToDoTaskDetailsView from './to-do-task-details.view';
import CountsWidgetView from './widgets/count-widget.view';

export default function TodoManagementView() {

  ViewBase.call(this);

  let inputDataModel = {
    taskTotal: 0,
    complete_mandatoty: 0,
    complete_optional: 0,
    nonComplete_mandatory: 0,
    nonComplete_optional: 0,
    site_total: 0,
    site_complete: 0,
    site_nonComplete: 0,
    filter: "Task^^",
    fromDate: "",
    toDate: "",
    selectedTasksList: [],
    selectedTaskListArr: [],
    selectedtasksTxt: "",
    selectedSites: [],
    pageIndex: 1,
    pageSize: 10,
    totalCount: 0,
    task: {
      total: "0",
      complete: { mandatory: "0", optional: "0" },
      notComplete: { mandatory: "0", optional: "0" }
    },
    site: { total: "0", complete: "0", notComplete: "0" },
    taskList: [],
    siteList: [],
    colors: {
      task_total: "l-bg-blue-light",
      complete_mandatory: "l-bg-white",
      complete_optional: "l-bg-white",
      nonComplete_mandatory: "l-bg-white",
      nonComplete_optional: "l-bg-white",
      site_total: "l-bg-white",
      site_ok: "l-bg-white",
      site_complete: "l-bg-white",
      site_nonComplete: "l-bg-white"
    }
  };

  let mandatoryType = "";
  let isUserAtributeListOpen = false;
  let isTaskDetailShow = false;
  let isSiteDetailShow = false;
  let searchType = "";
  let selectedAttributeList = [];
  let _windowTitle = "";
  let isTasks = true;
  let selectedItem;
  let selectedSiteItem;

  let _clearFilter = () => {
    inputDataModel.selectedSites = [];
    inputDataModel.selectedTaskListArr = [];
    inputDataModel.selectedTasksList = [];
    inputDataModel.selectedtasksTxt = "";
    _initControls();
  }

  let _search = () => {
    inputDataModel.pageIndex = 1;
    _getSiteNumbers();
    _getTaskNumbers();
    _getData();
  }

  let _getTaskNumbers = () => {
    return taskTodoModel.getTaskNumbers(inputDataModel)
      .then((result) => {
        inputDataModel.taskTotal = Number(result.totalDetails[0]["total"]).toLocaleString('en-US');
        inputDataModel.complete_mandatoty = Number(result.totalDetails[0]["completeMandatory"]).toLocaleString('en-US');
        inputDataModel.complete_optional = Number(result.totalDetails[0]["completeOptional"]).toLocaleString('en-US');
        inputDataModel.nonComplete_mandatory = Number(result.totalDetails[0]["notCompleteMandatory"]).toLocaleString('en-US');
        inputDataModel.nonComplete_optional = Number(result.totalDetails[0]["notCompleteOptional"]).toLocaleString('en-US');
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let _getSiteNumbers = () => {
    return taskTodoModel.getSiteNumbers(inputDataModel)
      .then((result) => {
        inputDataModel.site_total = Number(result.totalDetails[0]["total"]).toLocaleString('en-US');
        inputDataModel.site_complete = Number(result.totalDetails[0]["completeTotal"]).toLocaleString('en-US');
        inputDataModel.site_nonComplete = Number(result.totalDetails[0]["notCompleteTotal"]).toLocaleString('en-US');
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let _getTaskList = () => {
    this.showLoading();

    return taskTodoModel.getTaskList(inputDataModel)
      .then((result) => {
        inputDataModel.taskList = result.data;
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let _getSiteList = () => {
    this.showLoading();

    return taskTodoModel.getSiteList(inputDataModel)
      .then((result) => {
        inputDataModel.siteList = result.data;
        inputDataModel.totalCount = result.total;
        inputDataModel.pageIndex = result.pageIndex;
        inputDataModel.pageSize = result.pageSize;
      })
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let _getData = () => {
    if (isTasks) {
      _getTaskList();
    } else {
      _getSiteList();
    }
  }

  let _initControls = () => {
    isTasks = true;
    inputDataModel.fromDate = moment(new Date()).format(FORMATS.apiDateFormat);
    inputDataModel.toDate = moment(new Date()).format(FORMATS.apiDateFormat);
    let colors = {
      task_total: "l-bg-blue-light", complete_mandatory: "l-bg-white", complete_optional: "l-bg-white",
      nonComplete_mandatory: "l-bg-white", nonComplete_optional: "l-bg-white", site_total: "l-bg-white", site_ok: "l-bg-white", site_complete: "l-bg-white", site_nonComplete: "l-bg-white"
    };
    inputDataModel.colors = colors;
    _getTaskNumbers();
    _getSiteNumbers();
    _getData();
  }

  let _downloadExcel = () => {
    this.showLoading();
    var fileName = uuidv4();

    return taskTodoModel.downloadExcel(inputDataModel, fileName, isTasks)
      .catch((error) => {
        this.handleError(error);
      })
      .finally(() => { this.hideLoading() });
  }

  let onPageSizeChanged = (pageIndex, pageSize) => {
    inputDataModel.pageIndex = pageIndex;
    inputDataModel.pageSize = pageSize;
    _getData();
  }

  let onPageChanged = (pageIndex) => {
    inputDataModel.pageIndex = pageIndex;
    _getData();
  }

  let _onDatePickerChange = (e) => {
    inputDataModel.fromDate = moment(e.detail.start).format(FORMATS.apiDateFormat);
    inputDataModel.toDate = moment(e.detail.end).format(FORMATS.apiDateFormat);
  }

  let _loadSearchTasks = (items) => {
    selectedAttributeList = items;
    searchType = "005";//tasks list
    _windowTitle = this.getText("LT00000110", "Tasks");
    isUserAtributeListOpen = true;
  }

  let _onAttributeClose = () => {
    isUserAtributeListOpen = false;
  }

  let _onDetailClose = () => {
    isTaskDetailShow = false;
  }

  let _onSiteDetailClose = () => {
    isSiteDetailShow = false;
  }

  let _onAttributeSave = (selectedList) => {
    if (searchType == "005") {
      inputDataModel.selectedtasksTxt = "";
      let _attrVal = "";
      let _arr = [];
      selectedList.forEach(function (item) {
        _attrVal += item.text + ','
        _arr.push(item.value);
      });
      inputDataModel.selectedtasksTxt = _attrVal;
      inputDataModel.selectedTasksList = selectedList;
      inputDataModel.selectedTaskListArr = _arr;
      isUserAtributeListOpen = false;
    }
  }

  let _loadTaskList = () => {
    inputDataModel.pageIndex = '1';
    isTasks = true;
    _getData();
  }

  let _loadSiteList = () => {
    inputDataModel.pageIndex = '1';
    isTasks = false;
    _getData();
  }

  let _loadDetailsView = (item) => {
    selectedItem = item;
    isTaskDetailShow = true;
  }

  let _loadSiteDetailsView = (item, type) => {
    mandatoryType = type;
    selectedSiteItem = item;
    isSiteDetailShow = true;
  }

  let _changeDataSet = (type) => {
    inputDataModel.filter = type;
    _getData();
  }

  let isResultTableNotEmpty = () => {
    return isTasks && inputDataModel.taskList?.length > 0 ||
      !isTasks && inputDataModel.siteList?.length > 0;
  }

  return {
    oninit: (vnode) => {
      isTasks = true;
      _initControls();
    },
    view: (vnode) => {
      return [
        m('.row.g-2',
          // Search section
          m('.col-12',
            m('.card.mb-4',
              m('.card-body',
                m('.row.g-4',
                  m('.col-md-4.col-lg-3',
                    m('label.form-label', this.getText("LT00000070", "Date Range")),
                    m(DatePickerComponent, {
                      class: 'form-control',
                      isRange: true,
                      dateStart: moment(inputDataModel.fromDate, FORMATS.apiDateFormat).format(FORMATS.dateFormat),
                      dateEnd: moment(inputDataModel.toDate, FORMATS.apiDateFormat).format(FORMATS.dateFormat),
                      onselect: (e) => {
                        _onDatePickerChange(e);
                      }
                    })
                  ),
                  m('.col-md-4.col-lg-3', m('label.form-label', this.getText("LT00000110", "Tasks")),
                    m('input[type=text][title="' + inputDataModel.selectedtasksTxt + '"][value="' + inputDataModel.selectedtasksTxt + '"].form-control.form-control-bg', {
                      onclick: () => {
                        _loadSearchTasks(inputDataModel.selectedTasksList);
                      }
                    })
                  ),
                  m('.col-md-4.col-lg-3',
                    m('label.form-label', this.getText("LT00000071", "Site")),
                    m(SelectSiteComponent, {
                      selectedItemList: inputDataModel.selectedSites,
                      onChange: (s) => {
                        inputDataModel.selectedSites = s;
                      }
                    })
                  ),
                  m('.col-12.col-lg-3.gap-2.d-flex.align-items-end.justify-content-end.justify-content-lg-start',
                    m('button.btn.btn-primary', { onclick: _search }, this.getText("LT00000001", "Search")),
                    m('button.btn.btn-white', { onclick: _clearFilter }, this.getText("LT00000031", "Clear")),
                  ),
                )
              )
            ),
          ),
          // Filter section
          m('.col-12',
            m('.row.g-4.mb-4',
              m('.col-lg-7',
                m('.card.card-transparent',
                  m('.card-title.cross-title', m('h3', this.getText("LT00000110", "Tasks"))),
                  m('.card-body.mt-2',
                    m('.col-md-12.row',
                      m('.col-md-2.width-20'),
                      m('.col-md-5.width-40', m('.row.marginSetMinus', m('span', this.getText("LT00000177", "Completed")))),
                      m('.col-md-5.width-40', m('.row.marginSetMinus', m('span', this.getText("LT00000130", "Not Complete"))))
                    ),
                    m('.col-md-12.row',
                      m(CountsWidgetView, { onClick: _changeDataSet, data: inputDataModel, type: "tasks" })
                    )
                  )
                )
              ),
              m('.col-lg-5',
                m('.card.card-transparent',
                  m('.card-title.cross-title', m('h3', this.getText("LT00000071", "Site"))),
                  m('.card-body.mt-2',
                    m('.row.mt-1',
                      m(CountsWidgetView, { onClick: _changeDataSet, data: inputDataModel, type: "site" })
                    )
                  )
                )
              )
            ),
          ),
          // Table section
          m('.col-12',
            m('.card',
              m('.card-body',

                m('.d-flex.flex-wrap-reverse.justify-content-between.align-items-end.mb-2', { style: 'gap: 1.5em;' },
                  m('.worktype-legend.d-flex.flex-grow-1',
                    m('button.btn',
                      {
                        class: isTasks ? 'btn-primary' : 'btn-white',
                        onclick: _loadTaskList,
                        style: "min-width: 100px; border-top-right-radius: 0; border-bottom-right-radius: 0;"
                      },
                      this.getText("LT00000110", "Tasks")
                    ),
                    m('button.btn',
                      {
                        class: isTasks ? 'btn-white' : 'btn-primary',
                        onclick: _loadSiteList,
                        style: "min-width: 100px; border-top-left-radius: 0; border-bottom-left-radius: 0;"
                      },
                      this.getText("LT00000071", "Site")
                    ),
                  ),
                  m('.d-flex.justify-content-end.flex-grow-1',
                    m('a.btn.btn-primary',
                      {
                        class: isResultTableNotEmpty() ? '' : 'disabled',
                        onclick: _downloadExcel
                      },
                      m('i.bi.bi-file-earmark-arrow-down-fill'), this.getText("LT00000018", "Excel Download")
                    )
                  )
                ),

                m('.row',
                  m(".col-12.p-0",
                    m(".table-responsive",
                      isTasks && m("table.table", [
                        m("thead.thead-bggrey",
                          m("tr.align-middle",
                            [
                              m("th", { "scope": "col" }, this.getText("LT00000078", "Task Name")),
                              m("th", { "scope": "col" }, this.getText("LT00000115", "Mandatory")),
                              m("th", { "scope": "col" }, this.getText("LT00000132", "Date")),
                              m("th", { "scope": "col" }, this.getText("LT00000015", "Status")),
                              m("th.right", { "scope": "col" }, this.getText("LT00000133", "Task Completion Ratio"))
                            ])
                        ),
                        m("tbody",
                          inputDataModel.taskList.length == 0 &&
                          m("tr.align-middle",
                            m("td.text-center", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                          ),
                          inputDataModel.taskList.map(gc => [
                            m("tr",
                              m("td", gc.taskName),
                              m("td", gc.mandatoryFlag),
                              m("td", gc.scheduleDate),
                              m("td", gc.status == "Complete" && m('.badge.rounded-pill.green-bg-status', gc.status),
                                gc.status == "Not Complete" && m('.badge.rounded-pill.danger-bg-status', gc.status)),
                              m("td.right.anchorButton", { onclick: () => { _loadDetailsView(gc) } }, gc.ratio + '% (' + gc.completeCount + '/' + gc.totalCount + ')'),
                            )
                          ]),
                        )
                      ]),

                      !isTasks && m("table.table", [
                        m("thead.thead-bggrey",
                          m("tr.align-middle",
                            m("th", { "scope": "col" }, this.getText("LT00000071", "Site")),
                            m("th.right", { "scope": "col" }, this.getText("LT00000137", "All Tasks Completion Ratio")),
                            m("th.right", { "scope": "col" }, this.getText("LT00000138", "Mandatory Tasks Completion Ratio")),
                            m("th.right", { "scope": "col" }, this.getText("LT00000139", "Optional Tasks Completion Ratio"))
                          )
                        ),
                        m("tbody",
                          inputDataModel.siteList.length == 0 &&
                          m("tr.align-middle",
                            m("td.text-center", { "colspan": "7" }, this.getText("EM00000141", "No records found."))
                          ),
                          inputDataModel.siteList.map(gc => [
                            m("tr",
                              m("td", gc.siteName),
                              m("td.right.anchorButton", { onclick: () => { _loadSiteDetailsView(gc, "") } }, gc.completeRatio + '%'),
                              m("td.right.anchorButton", { onclick: () => { _loadSiteDetailsView(gc, "Y") } }, gc.mandatoryCompleteRatio + '%'),
                              m("td.right.anchorButton", { onclick: () => { _loadSiteDetailsView(gc, "N") } }, gc.optionalCompleteRatio + '%')
                            )
                          ]),
                        )
                      ])
                    ),
                    isResultTableNotEmpty() &&
                    m(".px-3",
                      m(paginationComponent, { currentPage: inputDataModel.pageIndex, pageSize: inputDataModel.pageSize, totalItems: inputDataModel.totalCount, onPageChanged: onPageChanged, onPageSizeChanged: onPageSizeChanged })
                    )
                  )
                )
              ),

            )
          ),
        ),
        m(Dialog, {
          isOpen: isUserAtributeListOpen,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: () => { isUserAtributeListOpen = false; },
          title: _windowTitle,
          content: m(UserAttributeListComponent, { type: searchType, masterId: inputDataModel.masterId, selectedAttribute: selectedAttributeList, onSave: _onAttributeSave, onAddClose: _onAttributeClose }),
          "class": "cui-dialog-xxl"
        }),
        m(Dialog, {
          isOpen: isTaskDetailShow,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: () => { isTaskDetailShow = false; },
          title: this.getText("LT00000108", "Details"),
          content: m(ToDoTaskDetailsView, { parentEntity: selectedItem, onClose: _onDetailClose }),
          "class": "cui-dialog-xxl"
        }),
        m(Dialog, {
          isOpen: isSiteDetailShow,
          transitionDuration: 200,
          closeOnOutsideClick: false,
          onClose: () => { isSiteDetailShow = false; },
          title: this.getText("LT00000108", "Details"),
          content: m(ToDoSiteDetailsView, { parentEntity: selectedSiteItem, filterparentParams: inputDataModel, type: mandatoryType, onClose: _onSiteDetailClose }),
          "class": "cui-dialog-xxl"
        }),
        this.getBaseViews()
      ]
    }
  }
}
